import ReceiptIcon from "@material-ui/icons/Receipt";
import { IRoute } from "src/common/typings/routes";
import { InvoicesModule } from "./InvoicesModule";
import { InvoicesList } from "./pages/ListOfInvoices";

export const InvoiceRoute: IRoute = {
  title: "Invoices",
  path: "/invoices",
  icon: ReceiptIcon,
  component: InvoicesModule,
  subRoutes: [
    {
      component: InvoicesList,
      path: "/list-invoices",
      title: "List of Invoices",
    },
    // {
    //   component: WODetails,
    //   path: "/work-order-details",
    //   pathParam: "/:id/:ordNum",
    //   title: "Work Order Details",
    //   noDrawer: true,
    // },
  ],
};
